// FUNÇÕES/MÓDULOS SITE
import HoverBackgroundGradient from './modules/Animation/hover_bg-gradient'
import ScrollSmooth from './modules/Animation/scrollLenis'
import AnimationElements  from './modules/Animation/enterElements'
import Footer from './modules/Layouts/footer'
import Menu from './modules/Layouts/menu'
import AnchorLinks from './modules/Utils/anchor_links'
import ImageEnter from './modules/Animation/imageEnter'
import ImagesHovers from './modules/Animation/imageHovers'
import infinityText from './modules/Animation/infinityText';
import removeEmptyImg from './modules/Utils/removeEmptyImg'
import forms from './modules/Forms/forms'
import changeLang from './modules/Utils/changeLang'
import drawSvg from './modules/Animation/drawSvg'

changeLang();
//aplica display: none em imagens sem src/sem cadastro
removeEmptyImg();
//forms
forms();
// Layout
//Footer()
Menu()
// Animations
//ScrollSmooth()
drawSvg()
infinityText()
AnimationElements()
HoverBackgroundGradient()
ImageEnter()
ImagesHovers()

// Utils
AnchorLinks()
